import Textfield from '@web-ui-kit/text-field'
import Textarea from '@web-ui-kit/textarea'
import Checkbox from '@web-ui-kit/checkbox'
import * as Sc from './CreateOrUpdateLinkForm.styles'
import i18n from 'i18n'

const URL_REGEX = /^(http|https):\/\/[^ "]+$/

const CreateOrUpdateLinkForm = ({ handleChangeField, linkData }) => {
  const checkUrl = () => {
    if (linkData.url === '') return false
    return !URL_REGEX.test(linkData.url)
  }

  const handleChangeFormField = (event) => {
    const { target } = event
    const fieldName = target.id
    let fieldValue = target.value
    if (target.id === 'shared') {
      fieldValue = target.checked
    }

    handleChangeField(fieldName, fieldValue)
  }

  return (
    <Sc.FormLinkBody>
      <Textfield
        dataTestId='link-title-input'
        id='title'
        label={`${i18n.t('Título')}*`}
        onChange={handleChangeFormField}
        type='text'
        value={linkData.title}
      />
      <Textarea
        dataTestId='link-description-input'
        enableResize={false}
        id='description'
        label={i18n.t('Descripción')}
        onChange={handleChangeFormField}
        value={linkData.description}
      />
      <Textfield
        dataTestId='link-url-input'
        errorMessage={checkUrl() ? i18n.t('No es una url válida') : ''}
        id='url'
        label={`${i18n.t('URL del enlace')}*`}
        onChange={handleChangeFormField}
        status={checkUrl() ? 'error' : 'default'}
        type='text'
        value={linkData.url}
      />
      <Checkbox
        checked={linkData.shared}
        dataTestId='link-share-checkbox'
        id='shared'
        label={i18n.t('¿Quieres compartir este enlace con tus clases?')}
        onChange={handleChangeFormField}
      />
    </Sc.FormLinkBody>
  )
}

export default CreateOrUpdateLinkForm
